import { DeviationShared } from '../../deviation/models/deviationShared';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { BaseServices } from './../../kuba.services';
import { Pagination, PaginatedResult } from 'src/app/_models/options';
import { HttpClient, HttpHeaderResponse, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import { SessionFeature } from 'src/app/_models';
import { PagedResponse } from '../../shared/models/pagedResponse';
import { PaginationRequest } from '../../shared/models/paginationRequest';
import { DeviationFilterDto } from '../models/deviationFilterRequest';
import { DeviationListDto } from '../models/deviationListDto';

@Injectable()
export class DeviationServices {
  _caseType: Observable<any> = null!;
  constructor(private http: HttpClient) {}

  clearCachedCaseType() {
    this._caseType = null!;
  }

  /**
   * Validates and adds sorting parameters to HttpParams
   * @param params - Existing HttpParams
   * @param request - PaginationRequest containing sort info
   * @returns Updated HttpParams with sorting parameters
   */
  private addSortingParams(params: HttpParams, request: PaginationRequest): HttpParams {
    let updatedParams = params;

    if (request.sortColumn) {
      updatedParams = updatedParams.set('sortColumn', request.sortColumn);
    }
    if (request.sortDirection) {
      updatedParams = updatedParams.set('sortDirection', request.sortDirection);
    }

    return updatedParams;
  }

  /**
   * Adds filter parameters to HttpParams
   * @param params - Existing HttpParams
   * @param filter - DeviationFilterDto containing filter values
   * @returns Updated HttpParams with filter parameters
   */
  private addFilterParams(params: HttpParams, filter?: DeviationFilterDto): HttpParams {
    let updatedParams = params;

    if (filter) {
      Object.keys(filter).forEach(key => {
        const value = filter[key as keyof DeviationFilterDto];
        if (value !== undefined && value !== null && value !== '') {
          updatedParams = updatedParams.set(key, value.toString());
        }
      });
    }

    return updatedParams;
  }

  // bind the type of case
  getAllCaseType() {
    return this.http
      .get(
        environment.BASE_URL +
        '/casetypes/' +
        BaseServices.BusinessId +
        '/' +
        BaseServices.roleId
      )
      .map((result: any) => result);
  }
  getClients(id: number) {
    return this.http
      .get(environment.BASE_URL + '/client/getall/' + id)
      .map((result: any) => result);
  }
  getDeviationsByUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/deviationbyuser/' + id)
      .map((result: any) => result);
  }


  getModulesByDeviation(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.BASE_URL}/deviation/submodules`);
  }

  getDeviationsByUserPaged(
    userId: number,
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/deviationbyuserpaged/${userId}`,
      { params }
    );
  }

  addDeviation(data: any) {
    return this.http
      .post(environment.BASE_URL + '/DeviationHeader', data)
      .map((response: any) => {
        return response;
      });
  }

  getAllTopics(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/DeviationTopic/' + Id)
      .map((result: any) => result);
  }
  getTopicsForAdmin(riskId: number) {
    return this.http
      .get(environment.BASE_URL + '/topicsforadmin/' + riskId)
      .map((result: any) => result);
  }
  getDepartmentsForAdmin(riskId: number) {
    return this.http
      .get(environment.BASE_URL + '/departmentforadmin/' + riskId)
      .map((result: any) => result);
  }
  // add the type case
  addTypeCase(data: any) {
    return this.http
      .post(environment.BASE_URL + '/CaseType', data)
      .map((response: any) => {
        return response;
      });
  }
  // add  the department
  addDepartment(data: any) {
    return this.http
      .post(environment.BASE_URL + '/department', data)
      .map((response: any) => {
        return response;
      });
  }
  // update  the department
  updateDepartment(Id: number, data: any) {
    return this.http
      .put(environment.BASE_URL + '/department/' + Id, data)
      .map((response: any) => {
        return response;
      });
  }
  // delete  the department
  deleteDepartment(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/departmentdelete/' + Id)
      .map((response: any) => {
        return response;
      });
  }
  // update the typecase
  updateCaseType(Id: number, data: any) {
    return this.http
      .put(environment.BASE_URL + '/CaseType/' + Id, data)
      .map((response: any) => {
        return response;
      });
  }
  // delete the typecase
  deleteTypeCase(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/CaseType/' + Id)
      .map((response: any) => {
        return response;
      });
  }
  // delete the topics
  deleteTopics(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/Delete/' + Id)
      .map((response: any) => {
        return response;
      });
  }
  // add the topics
  addTopics(data: any) {
    return this.http
      .post(environment.BASE_URL + '/Save', data)
      .map((response: any) => {
        return response;
      });
  }
  // update the topics
  updateTopics(data: any) {
    return this.http
      .put(environment.BASE_URL + '/Update', data)
      .map((response: any) => {
        return response;
      });
  }

  deleteDeviation(id: any) {
    return this.http
      .delete(environment.BASE_URL + '/deviation/' + id)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }
  getUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/ContactLookup/' + id)
      .map((result: any) => result);
  }
  getDeviationByBusiness(id: number) {
    return this.http
      .get(environment.BASE_URL + '/deviationslist/' + id)
      .map((result: any) => result);
  }
  getDeviationByPortal(portalId: number) {
    return this.http
      .get(environment.BASE_URL + '/portaldeviationslist/' + portalId)
      .map((result: any) => result);
  }
  getDeviationByAdmin(portalId: number) {
    return this.http
      .get(environment.BASE_URL + '/admindeviationslist/' + portalId)
      .map((result: any) => result);
  }
  getFeatureByBusiness(id: number): Observable<string> {
    return this.http.get<string>(`${environment.BASE_URL}/featurelist/${id}`);
  }
  // bind business dropdown
  getBusiness() {
    return this.http
      .get(environment.BASE_URL + '/businesses')
      .map((result: any) => result);
  }
  // bind deviation list
  getDeviationListWithDateFilter(startDate: string, endDate: string) {
    return this.http
      .get(`${environment.BASE_URL}/deviations/${startDate}/${endDate}`)
      .map(result => result);
  }
  getAllDeviationByDepartment(userId: any) {
    return this.http
      .get(`${environment.BASE_URL}/deviationbydepartment/${userId}`)
      .map(result => result);
  }

  getAllDeviationByDepartmentPaged(
    userId: any,
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/deviationbydepartmentpaged/${userId}`,
      { params }
    );
  }

  saveDocument(document: any) {
    return this.http
      .post(
        environment.BASE_URL + '/file/upload/business/followup/deviation-docs',
        document
      )
      .map(result => result);
  }

  getById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/deviation/' + id)
      .map(result => result);
  }

  getDeviationListPagedAdmin(
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/deviationslistpagedadmin`,
      { params }
    );
  }

  getDeviationListPagedByBusinessId(
    applicationId: number,
    request: PaginationRequest,
    businessId?: number,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('applicationId', applicationId.toString())
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    if (businessId) {
      params = params.set('businessId', businessId.toString());
    }

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    const url = businessId
      ? `${environment.BASE_URL}/deviationslistpaged/${businessId}`
      : `${environment.BASE_URL}/deviationslistpaged/0`;

    return this.http.get<PagedResponse<DeviationListDto>>(url, { params });
  }

  portalDeviationPagedList(
    portalId: number,
    userId: number,
    isPortalManager: boolean,
    applicationId: number,
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('portalId', portalId.toString())
      .set('userId', userId.toString())
      .set('isPortalManager', isPortalManager.toString())
      .set('applicationId', applicationId.toString())
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/portaldeviationslistpaged/${portalId}`,
      { params }
    );
  }

  getRModeFeature() {
    return this.http
      .get<HttpHeaderResponse>(
        environment.BASE_URL + '/rmode-feature/' + BaseServices.BusinessId
      )
      .pipe(
        map((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }

  /**
   * Clear cached topics
   */
  clearCachedTopic() {
  }
}
